// @ts-nocheck
import React from 'react';

const SvgChevronUp = props => (
  <svg viewBox="0 0 64 64" {...props}>
    <path
      d="M45.617 38.454l-13.59-13.597-13.59 13.597a2 2 0 0 1-2.828-2.83l15.004-15.012a2 2 0 0 1 2.829 0l15.005 15.012a2 2 0 0 1-2.83 2.83z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgChevronUp;
